import * as React from "react";
import {Component} from "react";
import styles from "../../styles/wizards/superadmin/AddProductAttributeTemplateGroupWizard.scss";
import autobind from "autobind-decorator";
import AddProductAttributeTemplateGroupIcon from "../../assets/images/add-product-attribute-group-64x64.svg";
import {mapStateToProps, setTableParams, validateForm} from "../../core/utils";
import {withRouter} from "react-router";
import {setNotification} from "../../redux/actions/general/notification";
import {
    createProductAttributeTemplateGroup,
    listProductAttributeTemplateGroups
} from "../../redux/actions/table/superadmin/product_attribute_template_groups";
import AddProductAttributeTemplateGroupForm
    from "../../forms/superadmin/add_product_attribute_template_group_wizard/AddProductAttributeTemplateGroupForm";

@withRouter
@mapStateToProps(state => ({
    table: state.table["superadmin_product_attribute_template_groups"],
}))
class AddProductAttributeTemplateGroupWizard extends Component {
    @autobind
    _handleSubmit(formData) {
        const {edit} = formData;
        
        return validateForm(
            createProductAttributeTemplateGroup(formData).then(({response}) => {
                listProductAttributeTemplateGroups().then(() => {
                    if(edit) {
                        setTableParams('superadmin_product_attribute_template_groups', {
                            clicked_row: response.data.id
                        });
                    }
                });

                setTableParams('superadmin_product_attribute_template_groups', {
                    actioned_row: undefined,
                    selected_rows: []
                });

                this.props.onClose();

                setNotification("You have successfully added a new product attribute template group.");
            })
        );
    }

    render() {
        return (
            <>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <span>Add product attribute template group</span>
                        <span>Add product attribute template group to the application</span>
                    </div>
                    <div className={styles.right}>
                        <AddProductAttributeTemplateGroupIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    <AddProductAttributeTemplateGroupForm onSubmit={this._handleSubmit} />
                </div>
            </>
        );
    }
}

export default AddProductAttributeTemplateGroupWizard;